import { render, staticRenderFns } from "./FiltersValueGroupAdd.vue?vue&type=template&id=0bc8265c"
import script from "./FiltersValueGroupAdd.vue?vue&type=script&lang=js"
export * from "./FiltersValueGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports